<!-- TODO - Format as inline more nicely -->
<!-- Can be displayed only after the  dataLoaded==true on the template! -->
<template>
  <v-layout class="date-time-picker--container" row wrap>
    <v-flex :sm6="showTime" :sm12="!showTime">
      <v-text-field
        v-model="date" @blur="onBlur" @focus="$event.target.select()"
        v-on:keyup.enter.native="onPressedEnter"
        @change="$emit('change')"
        :label="labels[0]"
        :error-messages="errorMessages"
        data-test="date"
      ></v-text-field>
    </v-flex>
    <v-flex sm6 v-if="showTime">
      <v-text-field
        v-model="time" @blur="onBlur" @focus="$event.target.select()"
        v-on:keyup.enter.native="onPressedEnter"
        @change="$emit('change')"
        :label="labels[1]"
        data-test="time"
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: String,
    errorMessages: Array,
    labels: {
      type: Array,
      default () { return [this.$t('date'), this.$t('time')] }
    },
    showTime: {
      type: Boolean,
      default: true
    }
  },
  created () {
    this.setLocals(this.value)
  },
  data: function () {
    return {
      date: '',
      time: ''
    }
  },
  methods: {
    setLocals (val) {
      this.date = val ? moment(val).format('D.M.YYYY') : ''
      this.time = val ? moment(val).format('HH:mm') : ''
    },
    guessDate (val) { // Validates String, returns String
      // this.date = moment(this.date, 'DD.MM.YYYY').format('D.M.YYYY')
      return moment(val, 'D.M.YYYY').isValid() ? moment(val, 'D.M.YYYY').format('D.M.YYYY') : ''
    },
    guessTime (val) { // Validates String, returns String
      // this.time = moment(this.time, 'HH:mm').format('HH:mm')
      if (!this.showTime) {
        return '00:00'
      }
      return moment(val, 'HH:mm').isValid() ? moment(val, 'HH:mm').format('HH:mm') : '00:00'
    },
    dtime (dateX, timeX) { // Accepts Strings, returns Moment
      if (dateX && timeX) {
        let date = moment(dateX, 'D.M.YYYY H:mm')
        let hours = moment(timeX, 'H:mm').hour()
        let minutes = moment(timeX, 'H:mm').minute()
        date.hour(hours)
        date.minute(minutes)
        return date
      }
      return moment.invalid()
    },
    onPressedEnter () {
      this.onBlur()
    },
    onBlur () {
      // 1. Validate input
      this.date = this.guessDate(this.date)
      this.time = this.guessTime(this.time)
      // 2. If valid, emit the values back
      let newDt = this.dtime(this.date, this.time)
      if (newDt.isValid()) {
        this.$emit('input', newDt.format())
      } else if (!this.date.length && !this.time.length) {
        // Needed for deleting the dateTime
        // Directly Emit the values back
        this.$emit('input', '')
      }
    },
    setNow () {
      this.date = moment().format('D.M.YYYY')
      this.time = moment().format('HH:mm')
      this.onBlur() // Must call onBlur which can emit the valid data back to the parent
    }
  },
  watch: {
    value () {
      this.setLocals(this.value)
    }
  }
}
</script>
